import { coveredWindow, currentReportingSunday, formatWeekLabel } from 'chery-kpi-engine';

export interface ReportingWeekDisplay {
  label: string;
  from: string;
  to: string;
}

/** The same abbreviations as the engine's week labels (`Intl` would print `Sept` in some locales). */
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const;

/** `2026-10-04` → `4 Oct`; the ISO date is read as a calendar date, so the viewer's time zone cannot move it. */
export const formatDayMonth = (isoDate: string): string => `${Number(isoDate.slice(8, 10))} ${MONTHS[Number(isoDate.slice(5, 7)) - 1]}`;

/** The current reporting week as the shared engine computes it — the same rule the service uses. */
export const reportingWeekDisplay = (now: Date): ReportingWeekDisplay => {
  const sunday = currentReportingSunday(now);
  const covered = coveredWindow(sunday);

  return { label: formatWeekLabel(sunday), from: formatDayMonth(covered.from), to: formatDayMonth(covered.to) };
};

/** `16.10 (Debian 16.10-1.pgdg120+1)` → `16.10`. */
export const shortPostgresVersion = (version: string): string => version.split(' ')[0] ?? version;
